module.exports = __webpack_public_path__ + "static/media/viadipapa_tn.f93bde3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/viadipapa_tn.jpg
// module id = 692
// module chunks = 0